module.exports = __webpack_public_path__ + "static/media/prawy-dol-geo.22335052.svg";